import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=bbe55574&"
import script from "./SurveyForm.vue?vue&type=script&lang=ts&"
export * from "./SurveyForm.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=bbe55574&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports